import * as moment from 'moment';

var dateValidate = {
  validate: (value) => {
    var validDate = moment(value, 'DD/MM/YYYY', true).isValid();
    return validDate;
  },
  message: 'Ingrese una fecha válida'
};

var ponderation = {
  validate: (value, args) => {
    return (value <= args.max);
  },
  params: ['max'],
  message: 'Ponderarión maxima: {max}%'
};

var qualification = {
  validate: (value, args) => {
    return (value >= 1 && value <= 7);
  },
  message: 'Ingrese una calificación válida'
}

export { dateValidate, ponderation, qualification };



// WEBPACK FOOTER //
// ./src/plugins/rules.js